
import { overrideStore, parametrize } from 'react-overridable';

import { RecordsList } from '@js/oarepo_ui/search/RecordsList';
import DatasetsResultsListItem from '@js/datasets/search/ResultsListItem';
const RecordsListWithProps = parametrize(RecordsList, { searchEndpoint: "/search" });

overrideStore.add('InvenioAppRDM.RecordsList.layout', RecordsListWithProps);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://datasets-v1.1.0.json', DatasetsResultsListItem);
